<!-- @format -->

<ng-container *transloco="let t">
  @for (error of ruleErrors; track error) {
    <div class="sis-mb-sm">
      @if (error.errorType === "LESS_SELECTIONS_REQUIRED") {
        <sis-contextual-notification [id]="error.errorId" [variant]="'danger'">
          {{ t("PLAN_EDIT.SELECTION_MODAL.RULE_ERRORS.LESS_SELECTIONS_REQUIRED") }}
        </sis-contextual-notification>
      }
    </div>
  }
</ng-container>
